import { apiCall } from "./imports"

export default {
    login(data) {
        return apiCall('post', "/management/auth/login", data)
    },
    getCsrf() {
        // return fetch(`http://localhost:8000/sanctum/csrf-cookie`);
        return apiCall('get', "/sanctum/csrf-cookie")
    }
}